module.exports = __webpack_public_path__ + "static/media/bgMountainEvening.4aa65a0d.jpg";